import {eatalianoAxios} from "@/data/api/http/axios";
import {CustomerSearchResult, User} from "@/data/entities/user";
import {Message} from "@/data/entities/message";

export const getCurrentUser = (): Promise<User | null> => (
    eatalianoAxios
        .get("/user/admin")
        .then(response => {
            if (response.status === 200)
                return response.data;

            return null;
        })
);

export const updatePassword = (currentPassword: string, newPassword: string): Promise<Message> => (
    eatalianoAxios
        .put("/user/password", {
            currentPassword: currentPassword,
            newPassword: newPassword
        })
        .then(response => response.data)
);

export const updatePreferredRestaurantLocation = (restaurantId: number): Promise<User> => (
    eatalianoAxios
        .put(`/user/restaurant`, {
            id: restaurantId,
        })
        .then(response => response.data)
);

/**
 * Searches customer accounts on name, email address or phone number. The
 * query must contain at least 2 characters.
 */
export const searchCustomers = (query: string): Promise<CustomerSearchResult[]> => (
    eatalianoAxios
        .get("/user/customers", {params: {query}})
        .then(response => response.data)
);
